import { VehiclePhotosType } from '../../../../../core/types/interface'
import { client } from '../../../client'

export class VehiclePhotosService {
  public async getPhotosByVehicleId(vehicleId: number) {
    return client.get<VehiclePhotosType>(`/vehicles/photos/${vehicleId}`)
  }
}
